/**
 * Visual helpers shared between PostCard and the post detail header — same
 * deterministic-colour avatar trick we already use in the chat inbox.
 */

const AVATAR_COLORS = [
  '#F87171', '#FB923C', '#FBBF24', '#34D399', '#22D3EE',
  '#60A5FA', '#A78BFA', '#F472B6', '#FB7185', '#4ADE80',
];

export function avatarColor(seed: string) {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function initials(name: string) {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
